export const envService = {
  envs: {
    dev: 'Développement',
    production: 'Production',
    staging: 'Recette',
    test: 'Test'
  },
  isRunningInDev: () => {
    return process.env.REACT_APP_SENTRY_ENV === envService.envs.dev;
  },
  isRunningInProd: () => {
    return process.env.REACT_APP_SENTRY_ENV === envService.envs.production;
  },
  isRunningInStaging: () => {
    return process.env.REACT_APP_SENTRY_ENV === envService.envs.staging;
  },
  isRunningInTest: () => {
    return process.env.REACT_APP_SENTRY_ENV === envService.envs.test;
  },
  isRunningInEnv: (environments) => {
    return environments.includes(process.env.REACT_APP_SENTRY_ENV);
  }
};
